"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptimizelyLimitation = exports.triggerModalFlow = exports.unlock = exports.isAllowedOrUnlock = exports.isAllowed = exports.hasUpgrade = exports.getLimitation = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _scriptHelper = require("./script-helper");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlHelper = require("./url-helper");

var _useDataApi = require("@eig-builder/core-utils/hooks/useDataApi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getLimitation = function getLimitation(limitationsResponse, limitationKey) {
  return (0, _get["default"])(limitationsResponse, 'limitations.' + limitationKey);
};

exports.getLimitation = getLimitation;
var hasUpgradeShape = {
  limitationsResponse: _propTypes["default"].shape({
    limitations: _propTypes["default"].object
  }).isRequired,
  limitationKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired
};

var hasUpgrade = function hasUpgrade(options) {
  _propTypes["default"].checkPropTypes(hasUpgradeShape, options, 'option', 'limitation-helper.hasUpgrade');

  var hasUpgrade = true;
  var noLimitationFound = true;
  var keysToCheck = (0, _isArray["default"])(options.limitationKey) ? options.limitationKey : [options.limitationKey];

  for (var key in keysToCheck) {
    var limitationKey = keysToCheck[key];
    var limitation = getLimitation(options.limitationsResponse, limitationKey);

    if (limitation && !(0, _isEmpty["default"])(limitation.upgrades)) {
      hasUpgrade = true;
      noLimitationFound = false;
      break;
    }
  }

  if (noLimitationFound) {
    hasUpgrade = false;
  }

  return hasUpgrade;
};

exports.hasUpgrade = hasUpgrade;
var isAllowedShape = {
  limitationsResponse: _propTypes["default"].shape({
    limitations: _propTypes["default"].object
  }).isRequired,
  limitationKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  value: _propTypes["default"].number // number or null

};

var isAllowed = function isAllowed(options) {
  _propTypes["default"].checkPropTypes(isAllowedShape, options, 'option', 'limitation-helper.isAllowed');

  var needToUnlock = true;
  var noLimitationFound = true;
  var keysToCheck = (0, _isArray["default"])(options.limitationKey) ? options.limitationKey : [options.limitationKey];

  for (var key in keysToCheck) {
    var limitationKey = keysToCheck[key];
    var limitation = getLimitation(options.limitationsResponse, limitationKey);

    if (limitation) {
      needToUnlock = limitation.value === true;
      noLimitationFound = false;

      if ((0, _isNumber["default"])(limitation.value)) {
        needToUnlock = options.value >= limitation.value;
        break;
      }
    }
  }

  if (noLimitationFound) {
    needToUnlock = false;
  }

  return !needToUnlock;
};

exports.isAllowed = isAllowed;
var isAllowedOrUnlockShape = {
  limitationsResponse: _propTypes["default"].shape({
    limitations: _propTypes["default"].object
  }).isRequired,
  limitationKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  value: _propTypes["default"].number,
  // number or null
  successUrl: _propTypes["default"].string.isRequired,
  errorUrl: _propTypes["default"].string.isRequired,
  success: _propTypes["default"].func.isRequired,
  openInNewTab: _propTypes["default"].bool,
  error: _propTypes["default"].func,
  extraInfo: _propTypes["default"].object
};

var isAllowedOrUnlock = function isAllowedOrUnlock(options) {
  _propTypes["default"].checkPropTypes(isAllowedOrUnlockShape, options, 'option', 'limitation-helper.isAllowedOrUnlock');

  var keysToCheck = (0, _isArray["default"])(options.limitationKey) ? options.limitationKey : [options.limitationKey];

  for (var key in keysToCheck) {
    var limitationKey = keysToCheck[key];
    var optionsToUnlock = (0, _cloneDeep["default"])(options);
    optionsToUnlock.limitationKey = limitationKey;

    if (!isAllowed(optionsToUnlock)) {
      unlock(optionsToUnlock);
      return;
    }
  } // Remove cache to reset the limitation getters and dependents


  (0, _useDataApi.clearCache)();
  options.success();
};

exports.isAllowedOrUnlock = isAllowedOrUnlock;
var unlockShape = {
  limitationsResponse: _propTypes["default"].shape({
    limitations: _propTypes["default"].object
  }).isRequired,
  limitationKey: _propTypes["default"].string.isRequired,
  successUrl: _propTypes["default"].string.isRequired,
  errorUrl: _propTypes["default"].string.isRequired,
  success: _propTypes["default"].func.isRequired,
  openInNewTab: _propTypes["default"].bool,
  error: _propTypes["default"].func,
  extraInfo: _propTypes["default"].object
};

var unlock = function unlock(options) {
  _propTypes["default"].checkPropTypes(unlockShape, options, 'option', 'limitation-helper.unlock');

  window.BuilderCheckout = window.BuilderCheckout || function () {
    ;
    (window.BuilderCheckout.q = window.BuilderCheckout.q || []).push(arguments);
  };

  (0, _scriptHelper.IncludeJavaScript)((0, _urlHelper.getUrl)(_urlHelper.siteNames.CP_CHECKOUT, '/sdk.js'), 'checkout-sdk');
  var limitation = getLimitation(options.limitationsResponse, options.limitationKey);
  var siteId = (0, _get["default"])(options.limitationsResponse, 'site_id');
  var extraInfo = options.extraInfo || {};
  window.BuilderCheckout('unlock', options.limitationKey, limitation, {
    success: options.success,
    successUrl: options.successUrl,
    error: options.error,
    errorUrl: options.errorUrl,
    openInNewTab: options.openInNewTab,
    extraInfo: _objectSpread({
      sideId: siteId,
      optimizelyLimitation: getOptimizelyLimitation()
    }, extraInfo)
  });
};

exports.unlock = unlock;

var triggerModalFlow = function triggerModalFlow(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  window.BuilderCheckout = window.BuilderCheckout || function () {
    ;
    (window.BuilderCheckout.q = window.BuilderCheckout.q || []).push(arguments);
  };

  (0, _scriptHelper.IncludeJavaScript)((0, _urlHelper.getUrl)(_urlHelper.siteNames.CP_CHECKOUT, '/sdk.js'), 'checkout-sdk');
  options = _objectSpread({}, options, {
    extraInfo: _objectSpread({}, options.extraInfo, {
      optimizelyLimitation: getOptimizelyLimitation()
    })
  });
  window.BuilderCheckout(type, options);
};

exports.triggerModalFlow = triggerModalFlow;

var getOptimizelyLimitation = function getOptimizelyLimitation() {
  if (window) {
    return window.sessionStorage.getItem('optimizelyLimitation') || '';
  }

  return '';
};
/* eslint-enable */


exports.getOptimizelyLimitation = getOptimizelyLimitation;